import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { getEnvironment } from '../../environment/environment';
import { AuthService } from '../../services/auth.service';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.page.html',
  standalone: true,
})
export class RedirectAuthPage {

  env = getEnvironment();
  pageUrl: string | null = null;
  token: string | null = null;

  constructor(
    public router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    private loading: LoadingService,
  ) {
    const queryParams = this.route.snapshot.queryParams;
    const rawUrl = queryParams['access_token'];

    if (rawUrl) {
      this.token = rawUrl || null;
    } else {
      this.router.navigateByUrl(`/`);

    }

    if (this.token && this.token != '') {
      this.login(this.token);
    }
  }

  // Simple Login
  async login(token: string) {
    this.loading.loadingShow();
    try {
      this.authService.clearDataWithoutRedirect();
      this.authService.successfullOAuthAuthorization(true, token, null, null, []);
      await this.authService.getUserByToken().toPromise();
      this.loading.dismiss();

      if (this.pageUrl) {
        this.router.navigateByUrl(`/${this.pageUrl}`);
      } else {
        this.router.navigateByUrl(`/`);
      }
    } catch (error) {
      this.authService.clearDataWithoutRedirect();
      this.loading.dismiss();
      this.router.navigateByUrl(`/`);
    }
  }

}
